export function publishReviewToastNotificationText(autoPublishFlag) {
  return autoPublishFlag
    ? 'Thank you for submitting review.'
    : 'Thank you for submitting review. It is currently under process.';
}
